import { render, staticRenderFns } from "./FinancialChannelSupplierStatistics.vue?vue&type=template&id=41cc5a70&"
import script from "./FinancialChannelSupplierStatistics.vue?vue&type=script&lang=ts&"
export * from "./FinancialChannelSupplierStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FinancialChannelSupplierStatistics.vue"
export default component.exports